import { render, staticRenderFns } from "./SingleSoundSelectorParameterType.vue?vue&type=template&id=dc194a5c"
import script from "./SingleSoundSelectorParameterType.vue?vue&type=script&lang=js"
export * from "./SingleSoundSelectorParameterType.vue?vue&type=script&lang=js"
import style0 from "./SingleSoundSelectorParameterType.vue?vue&type=style&index=0&id=dc194a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports